module.exports = __webpack_public_path__ + "static/media/alert.841ad412.svg";